import './components/GlobalMessage'
import './components/dynamicform'
import './components/hero'

addEventListener('DOMContentLoaded', () => {
	initializeHamburgerMenu()
})

/**
 * Menu for mobile.
 */
function initializeHamburgerMenu() {
	const header = document.body.querySelector('header')

	header.querySelector('.hamburger-toggle')?.addEventListener('click', function (event) {
		event.preventDefault()
		document.body.classList.toggle('menu-open')

		if (document.body.classList.contains('menu-open')) {
			header.scrollIntoView?.({
				behavior: 'smooth',
				block: 'start',
				inline: 'start',
			})
		}
	})

	const menuItems = header.querySelectorAll('li')

	/**
	 * For menu items with children the first touch should be ignored.
	 * This should reveal its children. Only when tapped again should it open the link.
	 */
	for (let a = 0; a < menuItems.length; a++) {
		const li = menuItems[a]
		
		if (!li.querySelector('ul')) {
			continue
		}
		
		const anchor = li.querySelector('a')
		anchor.addEventListener('click', function (event) {
			if (event.pointerType === 'touch') {
				if (!this.active) {
					event.preventDefault()
				}
				this.active = true
			}
		})

		anchor.addEventListener('mouseleave', function (event) {
			this.active = false
		})
	}
}
